<!-- QuickPlan 共用 Header -->
<template>
  <el-header>
    <div class="header-logo" @click="toIndex">
      QuickPlan
      <svg class="header-logo-icon">
        <g fill="none" fill-rule="nonzero">
          <image x="5" y="-6" width="60" height="20" href="/ONEAD_202107.svg" />
          <path fill="#231815" d="M1.411 6.702H.69V.362h.777v2.263a1.54 1.54 0 0 1 1.261-.62 1.93 1.93 0 0 1 .805.17c.242.107.455.27.62.477.171.223.3.475.382.743.093.303.139.618.136.935a2.625 2.625 0 0 1-.58 1.806c-.348.414-.863.65-1.404.648-.515.013-1-.246-1.275-.682v.6zm0-2.332c-.03.41.048.822.225 1.194a1.111 1.111 0 0 0 1.875.156c.274-.384.407-.851.375-1.322.04-.471-.086-.94-.354-1.33a1.09 1.09 0 0 0-.866-.43c-.346.004-.67.168-.88.444a1.95 1.95 0 0 0-.381 1.288h.006zM5.584 8.475l-.089-.73c.145.042.294.065.444.069a.852.852 0 0 0 .416-.089.682.682 0 0 0 .252-.245c.095-.187.175-.38.238-.58l.069-.19-1.746-4.603h.839l.954 2.659c.123.34.232.682.334 1.064a10.5 10.5 0 0 1 .32-1.05l.983-2.68h.777L7.63 6.777c-.124.357-.27.705-.437 1.043a1.548 1.548 0 0 1-.477.566c-.191.123-.414.184-.641.178a1.548 1.548 0 0 1-.49-.089z"/>
        </g>
      </svg>
    </div>
    <div class="header-info">
      <el-dropdown trigger="click" @visible-change="toggleMenu">
        <span class="header-info-button">
          Hi, {{ userName }} <i class="el-icon-arrow-down"></i>
          <!-- Hi, {{ userName }} <i :class="openMenu ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i> -->
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item><i class="fas fa-cog"></i> 修改密碼</el-dropdown-item> -->
          <el-dropdown-item @click.native="setShowUpdatePassword(true)"><i class="fas fa-sign-out-alt"></i> 修改密碼</el-dropdown-item>
          <el-dropdown-item @click.native="systemLogout('已成功登出')"><i class="fas fa-sign-out-alt"></i> 登出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  // @TODO 修改密碼
  name: 'AppHeader',
  data () {
    return {
      openMenu: false
    }
  },
  computed: {
    ...mapGetters('root', ['userName'])
  },
  methods: {
    ...mapActions('root', ['systemLogout', 'setShowUpdatePassword']),
    toIndex () {
      this.$router.push({ name: 'Index' })
    },
    toggleMenu (state) {
      this.openMenu = state
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/z-index.scss';
@import '@/styles/global.scss';
.el-header {
  background:#fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: map-get($z-index, AppHeader);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: map-get($globalVariable, HeaderHeight) !important;
  box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
  .header-logo {
    cursor: pointer;
    color: #4c4c4c;
    font-weight: 300;
    font-size: 24px;
    &-icon {
      margin-top: 14px;
      width:60px;
      height:9px;
    }
  }
  .header-info {
    cursor: pointer;
    &-button {
      padding: 6px 16px;
      background-color: #e89022;
      border-radius: 4px;
      box-shadow: 0 1px 2px 0 #4a4a4a;
      font-size: 14px;
      color: #fff;
      outline: none;
    }
  }
}
</style>
